import { render, staticRenderFns } from "./entry-certificate.vue?vue&type=template&id=82975f3c&scoped=true&"
import script from "./entry-certificate.vue?vue&type=script&lang=js&"
export * from "./entry-certificate.vue?vue&type=script&lang=js&"
import style0 from "./entry-certificate.vue?vue&type=style&index=0&id=82975f3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82975f3c",
  null
  
)

export default component.exports